import { membersApi } from '../api/membersApi'
import type { MemberUpdateInput } from '../types/member'

export const updateMember = async (member: MemberUpdateInput) => {
  try {
    const { data } = await membersApi.updateMember(member)
    return data
  } catch (error) {
    console.error(`Error updating members: `, error)
    throw error
  }
}
